import Vue from "vue";
import Component from "vue-class-component";

@Component
export class ResponsiveMixin extends Vue {
  public get isDesktop(): boolean {
    return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
  }
}
